export const requiredMsg = (prop: string) => `${prop} is a required field`;
export const greaterThenMsg = (prop: string, number: number) =>
  `${prop} must be greater than or equal to ${number}`;
export const minZeroMsg = (prop: string) => `${prop} must be at least 0`;
export const typeMsg = (prop: string, type: string) => `${prop} must be a ${type}`;
export const urlMsg = (prop: string) => `${prop} must be a valid url`;
